import { action, observable, reaction, makeObservable } from 'mobx';
import { Disposers, GuessServerTime, HttpPromiseState, logger } from '../../../lib/helpers';
import { DelayTimer } from '../../../lib/helpers/date/DelayTimer';
import { Classroom } from '../../classroom/models/classroom-models';
import { ClassroomLoaders } from '../../classroom/stores/classroom-loaders';
import {
    TeacherScheduleClassroomResponse,
    TeacherScheduleClassroomItem
} from 'domain/models/response-model';

export class TeacherScheduleStore {
    @observable.ref
    classroomsState: HttpPromiseState<readonly Classroom[]> | null;

    @observable.ref
    scheduleClassroomsState: HttpPromiseState<TeacherScheduleClassroomResponse> | null = null;

    classRooms: readonly Classroom[] | null = null;
    scheduledClassrooms: readonly TeacherScheduleClassroomItem[] | null = null;

    readonly delay = new DelayTimer(5000)

    serverTime: GuessServerTime;

    private minimal: number | null = null;

    private readonly disposers = new Disposers();

    @observable.ref
    suggestedClassRoom: TeacherScheduleClassroomItem | null = null;

    @observable.ref
    declinedAndSuggestedClassRoom: TeacherScheduleClassroomItem | null = null;

    @observable.ref
    acceptClassRoom: TeacherScheduleClassroomItem | null = null;

    constructor() {
        makeObservable(this);
        this.classroomsState = null;
        this.serverTime = new GuessServerTime();
        this.minimal = null;
        this.disposers.add(this.delay);
        this.disposers.add(this.serverTime);
        this.setup();
    }

    @action
    load = () => {
        if (this.scheduleClassroomsState?.isPending)
            return;
        this.delay.reset();
        this.scheduleClassroomsState = ClassroomLoaders.Teacher.getClassroomSchedule();
    };

    private setup() {
        this.disposers.add(reaction(
            () => this.scheduleClassroomsState?.value,
            this.updateMinimal
        ));
        this.disposers.add(reaction(
            () => [this.delay.reached, this.minimal, this.serverTime.now],
            this.refreshAfterDelay
        ));
    }

    @action
    updateMinimal = () => {
        this.minimal = null;
        if (this.scheduleClassroomsState?.isResolved !== true)
            return;
        this.scheduledClassrooms = this.scheduleClassroomsState.value.Events;
    };

    @action
    private refreshAfterDelay = () => {
        if (this.minimal === null)
            return;
        if (!this.serverTime.reached(this.minimal))
            return;
        if (!this.delay.reached)
            return;
        this.load();
    };

    dispose = () => {
        this.disposers.dispose();
    };
}
